import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { dispatch, useSelector } from 'store';
import { setCurrentEventId, setDataLoading } from 'store/reducers/menu';
import { withEventSearch } from 'utils/eventNavigation';
import useErrorSnackbar from './useErrorSnackbar';

export default function useNavToEvent() {
  const navigate = useNavigate();
  const errorSnackbar = useErrorSnackbar();
  const currentEventId = useSelector((state) => state.menu.currentEventId);

  const navToEvent = useCallback(
    (eventId: string | null | undefined, destination = '/event/main', options?: NavigateOptions) => {
      if (!eventId) {
        errorSnackbar({ message: 'No event to navigate to' } as Error);
        return;
      }

      const next = withEventSearch(destination, eventId);

      if (eventId !== currentEventId) {
        dispatch(setDataLoading(true));
        dispatch(setCurrentEventId(eventId));
      }

      navigate(next, options);
    },
    [currentEventId, errorSnackbar, navigate]
  );

  return navToEvent;
}
